import React from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import useFetchDeviceByEan from '../../hooks/useFetchDeviceByEan';

interface DeviceDetailsCrmInfosProps {
  ean: string | undefined;
}

const DeviceDetailsCrmInfos: React.FC<DeviceDetailsCrmInfosProps> = ({ ean }) => {
  const { t } = useTranslation();

  const { deviceResponse } = useFetchDeviceByEan({ ean: ean || '' });

  return (
    <>
      <Card className="shadow mt-3 text-center">
        <Card.Header className="bg-primary text-white clickable">
          <Card.Title className="fs-3 fw-semibold my-2">{t("devices.product.label.title")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={12} className='border-bottom border-2'>
              <span className='fs-5 fw-semibold text-muted'>{t("devices.crm.header")}</span>
              <span className='fs-5 fw-medium ms-1'>{deviceResponse?.crmInfo?.isInCrm ? t("yes") : t("no")}</span>
            </Col>

            <Col>
              <span className='fw-semibold'>{t("devices.product.label.title")} :</span>
              <div><a href={deviceResponse?.crmInfo?.product.link} target="_blank" rel="noopener noreferrer">{deviceResponse?.crmInfo?.product.name}</a></div>
              <div><span className='fw-semibold'>{t("description")} :</span> {deviceResponse?.crmInfo?.product.description || t("devices.product.label.noDescription")}</div>
            </Col>
            {deviceResponse?.crmInfo?.isShipped && (
              <>
                <Col>
                  <strong>{t("devices.customer.title")}:</strong>
                  <div><a href={deviceResponse?.crmInfo?.customer.link} target="_blank" rel="noopener noreferrer">{deviceResponse?.crmInfo?.customer.name}</a></div>
                  <div><strong>{t("devices.customer.clientCode")}:</strong> {deviceResponse?.crmInfo?.customer.clientCode || t("devices.product.label.noClientCode")}</div>
                  <div><strong>{t("devices.customer.address")}:</strong> {deviceResponse?.crmInfo?.customer.address}, {deviceResponse?.crmInfo?.customer.zip}, {deviceResponse?.crmInfo?.customer.town}</div>
                </Col>

                <ListGroup.Item>
                  <strong>{t("devices.shipment.title")}:</strong>
                  <div><a href={deviceResponse?.crmInfo?.shipment?.link} target="_blank" rel="noopener noreferrer">{t("devices.shipment.label.viewShipment")}</a></div>
                  <div><strong>{t("devices.shipment.label.isShipped")}:</strong> {deviceResponse?.crmInfo?.isShipped ? 'Yes' : 'No'}</div>
                </ListGroup.Item>
              </>
            )}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default DeviceDetailsCrmInfos;
